<template>
  <b-col
    @click="select"
    ref="top"
    align-v="stretch"
    class="border border-2 m-2 m-md-3 p-3 shadow-sm rounded link-pointer bg-white"
    :class="{ 'border-2 border-blue': isSelected }"
  >
    <b-row class="text-center text-md-left">
      <b-col cols="12" md="auto">
        <b-icon-record-circle-fill v-if="isSelected" variant="blue" font-scale="1.75" />
        <b-icon-circle v-else variant="blue-300" font-scale="1.75" />
      </b-col>
      <b-col>
        <p class="mb-2 text-blue-500 font-weight-bold lead">{{ label }}</p>
        <p class="text-blue-500 mt-3 mb-md-4">{{ description }}</p>
      </b-col>
      <b-col v-if="operator" cols="12" class="d-none d-md-block">
        <SecurePayment></SecurePayment>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import SecurePayment from '@/components/formOfPayment/SecurePayment.vue'

export default {
  name: 'PaymentType',
  components: {
    SecurePayment
  },
  props: {
    value: {},
    label: {
      required: true,
      type: String
    },
    operator: {
      type: Boolean,
      default: false
    },
    description: {
      required: true,
      type: String
    },
    innerValue: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSelected() {
      return this.innerValue === this.value
    }
  },
  data() {
    return {
      scrollArgs: { behavior: 'smooth', block: 'start', inline: 'nearest' }
    }
  },
  methods: {
    select() {
      if (this.disabled === true) {
        return
      }
      this.$emit('input', this.innerValue)
      if (this.$refs?.top) {
        this.$refs.top.scrollIntoView(this.scrollArgs)
      }
    }
  }
}
</script>
